<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
			<el-tabs v-model="type" @tab-click="handleClick">
				<el-tab-pane label="BTC充值" :name="1">
				</el-tab-pane>
				<el-tab-pane label="USDT充值" :name="2"></el-tab-pane>
			</el-tabs>
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search ref="buttonSearch" placeholder="搜索邮箱" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">添加背景</el-button>
					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量删除</el-button> -->

				</template>

				<!-- 高级搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="用户ID" class="mb-0">
							<el-input size="small" v-model="from.id" placeholder="搜索ID"></el-input>
						</el-form-item>
						<el-form-item label="ArenaID" class="mb-0">
							<el-input size="small" v-model="from.u_id" placeholder="搜索ArenaID"></el-input>
						</el-form-item>
						<el-form-item label="邮箱" class="mb-0">
							<el-input size="small" v-model="from.username" placeholder="搜索邮箱"></el-input>
						</el-form-item>
						
				

						<el-form-item label="状态" class="mb-0">
							<el-select v-model="from.status" size="small" placeholder="请选择查看类型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="待打款" :value="0"></el-option>
								<el-option label="交易成功" :value="1"></el-option>
								<el-option label="等待审核" :value="2"></el-option>
								<el-option label="打款失败" :value="3"></el-option>
								<el-option label="打款超时" :value="4"></el-option>
								<el-option label="取消充值" :value="5"></el-option>
								
							</el-select>
						</el-form-item>
						
					


						<el-form-item label="提交时间" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空筛选条件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
				<el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column>
				<el-table-column align="center" width="200" prop="card_number" label="充值用户">
					<template slot-scope="v">
						<el-avatar size="small" :src="v.row.head"></el-avatar>
						<!-- <div><span class="text-warning">ID：</span>{{v.row.user_id}}</div> -->
						<div><span class="text-warning">ArenaID：</span>{{v.row.u_id}}</div>
						<div><span class="text-warning">邮箱：</span>{{v.row.username}}</div>
						<div><span class="text-warning">语言：</span>{{v.row.lang_name}}</div>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="name" width="120" label="类型">
					<template slot-scope="v">
						<span v-if="v.row.type==1">BTC</span>
						<span v-if="v.row.type==2">USDT</span>
						<span v-if="v.row.type==3">转账</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="order_number" width="160" label="交易编号">
				</el-table-column>
				<el-table-column align="center" prop="money" width="120" label="充值金额">
					<template slot-scope="v">
						<span>$ {{v.row.money}}</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="money" width="120" label="提交金额">
					<template slot-scope="v">
						<span>$ {{v.row.sum_money}}</span>
					</template>
				</el-table-column>


				<el-table-column align="center" prop="currency" width="120" label="币数量">
				</el-table-column>
				
			

				<el-table-column align="center" prop="name" width="120" label="状态">
					<template slot-scope="v">
						<span style="color: #999;" v-if="v.row.status==0">待打款</span>
						<span style="color: green;" v-if="v.row.status==1">交易成功</span>
						<span style="color: #666;" v-if="v.row.status==2">等待审核</span>
						<span style="color: red;" v-if="v.row.status==3">打款失败</span>
						<span style="color: red;" v-if="v.row.status==4">打款超时</span>
						<span style="color: red;" v-if="v.row.status==5">取消打款</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="haxi" width="160" label="交易哈希">
					
				</el-table-column>
				<el-table-column align="center" prop="da_remark" width="120" label="打款备注">
				</el-table-column>
				<el-table-column align="center" prop="card_number" width="200" label="转账截图">
					<template slot-scope="v">
						<el-image v-if="v.row.img_list" style="width: 50px; height: 50px" v-for="(item,index) in v.row.img_arr" :key="index" :src="item"
						 :preview-src-list="v.row.img_arr">
						</el-image>
						<span v-else>-</span>
					</template>
					
				</el-table-column>
				
				<el-table-column align="center" prop="remark" width="120" label="审核失败原因">
					<template slot-scope="v">
						<span v-if="v.row.status==3">{{v.row.remark}}</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				
				
				
				<el-table-column align="center" prop="admin.name" width="200" label="最迟打款时间">
					<template slot-scope="v">
						<span v-if="v.row.status==0">{{v.row.end_time}}</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="admin.name" width="200" label="打款时间">
					<template slot-scope="v">
						<span v-if="v.row.status==1 || v.row.status==2">{{v.row.da_time}}</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="admin.name" width="200" label="取消时间">
					<template slot-scope="v">
						<span v-if="v.row.status==5">{{v.row.cancel_time}}</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="admin.name" width="200" label="交易完成时间">
					<template slot-scope="v">
						<span v-if="v.row.status==1">{{v.row.ok_time}}</span>
						<span v-else>-</span>
					</template>
				</el-table-column>



				<el-table-column align="center" prop="admin.name" width="120" label="操作员">
				</el-table-column>


				<el-table-column sortable="custom" align="center" prop="update_time" width="200" label="提交时间">
				</el-table-column>

				<el-table-column prop="id" fixed="right" align="center" width="180" label="操作">
					<template slot-scope="scope">
						<el-button-group v-show="scope.row.status==2">
							<el-button 
							:loading="layout.loading"
							v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row,1)">收款成功</el-button>
							<el-button v-auth="'edit'+auth_val" @click="openModel(scope.row,3)" size="mini" plain type="danger">收款失败</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog :title="form.status==1?'收款成功':'收款失败'" :visible.sync="createModel" top="5vh">
			<!-- 表单内容 -->
			<el-form :rules="rules" ref="form" :model="form" label-width="100px">

				<el-form-item v-show="form.status==3" label="收款失败说明" prop="remark">
					<el-input v-model="form.remark" placeholder="收款失败说明"
					 type="textarea"
					  :rows="5"
					 clearable size="small" style="width: 70%;"></el-input>
				</el-form-item>
				
				<el-form-item v-show="form.status==1" label="充值金额" prop="title">
					<el-input type="number" v-model="form.money" 
					placeholder="充值金额" 
					clearable size="small" style="width: 34%;"></el-input>
				</el-form-item>
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				//搜索数据
				from: {
					id: '',
					u_id: '',
					username: '',
					status: -1,
					time: [],
				},
				model_title: 'Pay',
				auth_val: 'Pay',
				preUrl: "apply/payList", //列表地址
				addUrl: "apply/addPay", //添加/修改地址
			
				type:1,
				tableData: [],
				form: {
					id: 0,
					remark: '',
					status:0,
					money:""
					
				},
				prop: 'create_time',
				sort: 'descending',
				rules: {
					
				},
				rule_list: [],
				check_img_list: []
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			//this.commonList('rule');
		},
		methods: {
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				this.$refs.form.validate(res => {
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 关闭模态框
					}
				})
			},
			

			// 打开模态框
			openModel(e, type) {
				// 修改
				this.form = {
					id:  e.id,
					remark: '',
					money: e.money,
					status:type
				}
				this.editIndex = e.id
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				console.log(this.tableData)
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空筛选条件
			clearSearch() {
				this.from = {
					id: '',
					u_id: '',
					username: '',
					status: -1,
					time: [],
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
		}
	}
</script>

<style>
</style>
